import { render, staticRenderFns } from "./IbxConfirmationModal.vue?vue&type=template&id=6a4c20d0&scoped=true"
import script from "./IbxConfirmationModal.vue?vue&type=script&lang=js"
export * from "./IbxConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./IbxConfirmationModal.vue?vue&type=style&index=0&id=6a4c20d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c20d0",
  null
  
)

export default component.exports